import { useContext } from 'react';
import { css } from '@emotion/react';
import dayjs from 'dayjs';
import { Logo } from '@frontend/assets';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text, TextLink } from '@frontend/design-system';
import { linkToWeave } from '../constants';
import { InsuranceReportContext } from '../dental-insurance-eligibility-report';

export const Footer = () => {
  const { t } = useTranslation('insuranceEligibilityReport');
  const { lastRetrievalDate } = useContext(InsuranceReportContext);
  const currentDate: string = dayjs(lastRetrievalDate || new Date()).format('DD MMMM YYYY, hh:mm A');

  return (
    <footer css={footerStyle}>
      <Logo />
      <Text textAlign='center'>
        {t('The data in this document was retrieved on: {{date}}', {
          date: currentDate,
        })}
      </Text>
      <div>
        <Text textAlign='center'>
          {t('Rendered by ')}
          <TextLink href={linkToWeave}>{t('Weave')}</TextLink>
        </Text>
      </div>
    </footer>
  );
};

const footerStyle = css`
  background-color: ${theme.colors.neutral30};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.spacing(2.5, 1)};
  bottom: 0;
  left: 0;
  right: 0;
  width: auto;
`;
